import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import Overview from 'pages/Entity/Artist/Overview/index';
import Airplay from 'pages/Entity/Artist/Airplay/index';
import Performance from 'pages/Entity/Artist/Performance/index';
import Charts from 'pages/Entity/Artist/Charts/index';
import Social from 'pages/Entity/Artist/Social/index';
import Territory from 'pages/Entity/Artist/Territory';
import Audience from 'pages/Audience';

interface IEntityArtistProps {
  pathPrefix: string;
  location: any;
}

const Artist: React.FC<IEntityArtistProps> = (props) => {
  const { location, pathPrefix } = props;
  return (
    <Switch location={location}>
      <Route
        path={`${pathPrefix}/artist/:entities/overview`}
        render={(routerProps): any => (
          <Overview {...routerProps} pathPrefix={pathPrefix} />
        )}
      />

      <Route
        path={`${pathPrefix}/artist/:entityId/social`}
        render={(routerProps): any => (
          <Social {...routerProps} pathPrefix={pathPrefix} />
        )}
      />
      <Route
        path={`${pathPrefix}/artist/:entities/charts`}
        render={(routerProps): any => (
          <Charts {...routerProps} pathPrefix={pathPrefix} />
        )}
      />
      <Route
        path={`${pathPrefix}/artist/:entities/airplay`}
        render={(routerProps): any => (
          <Airplay {...routerProps} pathPrefix={pathPrefix} />
        )}
      />
      <Route
        path={`${pathPrefix}/artist/:entities/performance`}
        render={(routerProps): any => (
          <Performance {...routerProps} pathPrefix={pathPrefix} />
        )}
      />
      <Route
        path={`${pathPrefix}/artist/:entityId/audience/ageGender`}
        render={(routerProps: any): any => <Audience {...routerProps} />}
      />
      <Route
        exact
        path={`${pathPrefix}/artist/:entities/audience/territory`}
        render={(routerProps): any => <Territory {...routerProps} />}
      />
      <Redirect
        exact
        from={`${pathPrefix}/artist/:entityId/audience`}
        to={`${pathPrefix}/artist/:entityId/audience/ageGender`}
      />
    </Switch>
  );
};

export default Artist;
